import { HTMLAttributes } from 'react';
import { TitledValueContainer } from './styles/titled-value';

interface ITitledValue {
	desc?: any;
	layout?: string;
	spacing?: number;
	valueSize?: number;
	display?: string;
	marginBottom?: number;
}

export const TitledValue: React.FC<HTMLAttributes<HTMLSpanElement> & ITitledValue> = ({
	title,
	desc,
	children,
	className,
	layout = 'horizontal',
	...rest
}) => (
	<TitledValueContainer className={className} {...rest}>
		{/* {icon || (iconType && <Icon type={iconType} className="me-1" theme={theme} />)} */}
		<span style={{ display: layout === 'vertical' ? 'block' : undefined }}>{title || desc} </span>
		<span className="desc-value">{children}</span>
	</TitledValueContainer>
);
